import {useState} from 'react'
import AppPermissionsList from './AppPermissionsList';
import AppPermissionsForm from './AppPermissionsForm';

const AppPermissions = () => {

    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AppPermissionsForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AppPermissionsList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default AppPermissions